import classNames from 'classnames';
import { motion, LayoutGroup } from 'framer-motion';

import { PersonalContentNavProps } from './PersonalContentNav.types';
import { chartConfigs } from './chartConfig';
import styles from './PersonalContentNav.module.scss';

const springTransition = { type: 'spring', stiffness: 500, damping: 35 };

export function PersonalContentNav({ activeChart, onChange }: PersonalContentNavProps) {
  return (
    <nav className={styles.nav}>
      <LayoutGroup>
        <div className={styles.nav__group}>
          {chartConfigs.map(({ id, label, IconComponent, isDisabled }, index) => {
            const isActiveChart = activeChart === id;
            return (
              <motion.button
                className={classNames(styles.chartButton, {
                  [styles.active]: isActiveChart,
                })}
                key={id}
                layout
                transition={springTransition}
                disabled={isDisabled}
                onClick={!isDisabled ? () => onChange(id) : undefined}
                title={label}
              >
                {isActiveChart && (
                  <motion.div className={styles.activeBackground} layoutId="activeTabBg" transition={springTransition}>
                    {index > 0 && <div className={styles.cornerLeft} />}
                    <div className={styles.cornerRight} />
                  </motion.div>
                )}
                <div className={styles.iconWrapper}>
                  <IconComponent
                    className={classNames(styles.chartIcon, {
                      [styles.active]: isActiveChart,
                    })}
                  />
                  {isDisabled && <span className={styles.soonRibbon}>SOON</span>}
                </div>
              </motion.button>
            );
          })}
        </div>
      </LayoutGroup>
    </nav>
  );
}
